export default __webpack_public_path__ + "static/noi2020honourableyushen-e7a95f774cfb8d6b96b3861323546570.jpg";